<template>
  <div>
    <el-select
      v-model="initValue"
      multiple
      filterable
      allow-create
      default-first-option
      remote
      :placeholder="placeholder"
      :remote-method="querySearch"
      @focus="handleFocus"
      @change="handleChange"
    >
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item"
        :value="item">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
      validator: value => {
        return value.every(item => typeof item === 'string')
      }
    },
    placeholder: {
      type: String,
      default: ''
    },
    queryApi: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      initValue: this.value,
      options: []
    }
  },
  watch: {
    value: {
      handler(val) {
        this.initValue = val
      },
      deep: true
    }
  },
  methods: {
    querySearch(query) {
      if (!query) {
        this.options = []
        return
      }
      const params = { tag: query }
      this.$service[this.queryApi](params).then(res => {
        this.options = res.tags
      })
    },
    handleFocus() {
      this.options = []
    },
    handleChange(value) {
      const filterText = this.initValue.filter(item => item.length <= 30)
      if (filterText.length < this.initValue.length) {
        this.initValue = filterText
        this.$message.warning('不能超过30个字符')
      }
      if (filterText.length > 50) {
        this.initValue.pop()
        filterText.pop()
        this.$message.warning('最多添加50个')
      }
      this.value.splice(0, this.value.length)
      this.value.push(...filterText)
      this.options = []
    }
  }
}
</script>

<style lang="stylus" scoped>
.el-select
  width 100%
  line-height normal
  >>>.el-select__tags
    margin-left 3px
  >>>.el-tag.el-tag--info
    background-color #fff3e6
    border-color #fff3e6
    color #ff8b00
  >>>.el-tag.el-tag--info .el-tag__close
    color #ff8b00
    background none
</style>
